import { useMutation } from "@tanstack/react-query";
import { uploadStoryFile } from "Api/Mutations/Stories/uploadStoryFile";

type Props = {
  onSuccess?: (url: string) => void;
  onError?: () => void;
};

/** Uploads a story image through our API to our blob storage and returns its public URL. */
export const useUploadStoryImageMutation = ({
  onSuccess,
  onError,
}: Props = {}) =>
  useMutation({
    mutationFn: (file: File) => uploadStoryFile("image", file),
    onSuccess,
    onError,
  });
